import $ from 'jquery';
// const footerInit = ()=> {
//
//     const svgLinesAnimation = () => {
//
//         const svgLines = document.querySelectorAll('.path__line');
//
//         svgLines.forEach((line) => {
//             let length = line.getTotalLength();
//             line.style.strokeDasharray = length;
//             line.style.strokeDashoffset = length;
//         });
//
//         const footerElm = document.querySelector('.footer__image_block');
//         const intersectionFooterObserver = new IntersectionObserver(function (entries) {
//             if (entries[0].intersectionRatio <= 0) return;
//             footerElm.classList.add('play');
//         }, {
//             threshold: 0.25,
//         });
//
//         intersectionFooterObserver.observe(footerElm);
//
//     }
//
//     svgLinesAnimation();
//
// }

const footerInit = () => {
    // $(()=>{
    //     $('.footer__mobile-toggle').click(function (){
    //         if(window.innerWidth <=767){
    //             $(this).toggleClass('opened').find('+ .footer__dropdown').slideToggle(200);
    //
    //         }
    //     })
    // })

    $('#to-top-btn').click(function () {
        // $('html, body').animate({ scrollTop: 0 }, 0); // 600 мс
        window.scrollTo(0, 0);
        return false;
    });
}
export default footerInit;
